<div class="is-relative mt-5">
    <isav-tabs [borders]="true" panelClass="content-type-form">
        <isav-tab title="edit">
            <ng-container *isavTabTitle>Edit</ng-container>
            <isav-education-and-trening-form
                *isavTabContent
                [value]="data"
                (save)="onSave($event)"
                (publish)="publish($event)"
                (unpublish)="unpublish()"
                (remove)="onDelete()"
            ></isav-education-and-trening-form>
        </isav-tab>
        <isav-tab title="ownership">
            <ng-container *isavTabTitle>Ownership</ng-container>
            <isav-content-ownership
                *isavTabContent
                [contentIri]="data['@id']"
            ></isav-content-ownership>
        </isav-tab>
    </isav-tabs>
    <isav-loader-overlay *ngIf="loading"></isav-loader-overlay>
</div>
